import { TweenLite, Expo } from "gsap";

export default function init() {
  const gridItems = document.querySelectorAll('.grid-nav__item:not(.grid-nav__item--svg');
  [].forEach.call( gridItems, function ( gridItem ) {
    let c = gridItem.querySelector('.hover-transform');
    gridItem.addEventListener('mouseenter', function(){
      TweenLite.to(c, .2, {y:-7, force3D:false, ease: Expo.easeOut});
    })
  });
  [].forEach.call( gridItems, function ( gridItem ) {
    let c = gridItem.querySelector('.hover-transform');
    gridItem.addEventListener('mouseleave', function(){
      TweenLite.to(c, .2, {y:0, force3D:false, ease: Expo.easeOut});
    })
  })
};
